import React from "react";
import { Layout, Row, Col, Badge, Menu, Dropdown, message } from "antd";
import { BellFilled, DownOutlined, UserOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import Sidebar from "./Sidebar";
import firebase from "../config/FirebaseConfig";

const { Header, Content } = Layout;

export default function Dashboard(props) {
  const history = useHistory();
  const handleLogOut = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        message.success("Anda berhasil log out");
        localStorage.clear();
        history.push("/");
      });
  };

  const navbarMenu = (
    <Menu>
      {/* <Menu.Item>Change Profile</Menu.Item> */}
      <Menu.Item onClick={handleLogOut}>Log Out</Menu.Item>
    </Menu>
  );

  return (
    <Layout style={{ minHeight: "100vh", backgroundColor: "#ffffff" }}>
      <Sidebar />
      <Layout className="site-layout">
        <Header className="admin_header">
          <Row justify="end" style={{ marginRight: 48 }}>
            <Col style={{ marginRight: 16 }}>
              <Badge count={0} showZero size="small">
                <BellFilled style={{ fontSize: 24, color: "#25A6E3" }} />
              </Badge>
            </Col>
            <Col>
              <Dropdown overlay={navbarMenu}>
                <Row align="middle" style={{ fontSize: 24 }}>
                  <UserOutlined style={{ color: "#25A6E3" }} />
                  &nbsp; Admin &nbsp;
                  <DownOutlined style={{ fontSize: 16, color: "#25A6E3" }} />
                </Row>
              </Dropdown>
            </Col>
          </Row>
        </Header>
        <Content
          style={{
            backgroundColor: "#ffffff",
            margin: 0,
            paddingLeft: 32,
          }}
        >
          {props.children}
        </Content>
      </Layout>
    </Layout>
  );
}
